  export const initialSelectMealList = {
    selectedMeals: {
      Friday: {
        lunch: 0,
        dinner: 0,
        breakfast: 0,
      },
      Monday: {
        lunch: 0,
        dinner: 0,
        breakfast: 0,
      },
      Sunday: {
        lunch: 0,
        dinner: 0,
        breakfast: 0,
      },
      Tuesday: {
        lunch: 0,
        dinner: 0,
        breakfast: 0,
      },
      Saturday: {
        lunch: 0,
        dinner: 0,
        breakfast: 0,
      },
      Thursday: {
        lunch: 0,
        dinner: 0,
        breakfast: 0,
      },
      Wednesday: {
        lunch: 0,
        dinner: 0,
        breakfast: 0,
      },
    },
  };


  export const dayOrder = [
    "Monday",
    "Friday",
    "Tuesday",
    "Saturday",
    "Wednesday",
    "Sunday",
    "Thursday",
  ];
 export const dayOrderForRecipie = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];